import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-[#1a2837] to-gray-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <span className="text-3xl font-bold tracking-tight text-white">
                INTER<span className="text-[#C9A961]">PRODUCTS</span>
              </span>
            </div>
            <p className="text-gray-300 leading-relaxed mb-6">
              Conectando o mercado brasileiro aos melhores produtos do cenário internacional com excelência e transparência.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-[#C9A961] rounded-lg flex items-center justify-center transition-all"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-[#C9A961] rounded-lg flex items-center justify-center transition-all"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-white/10 hover:bg-[#C9A961] rounded-lg flex items-center justify-center transition-all"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#C9A961]">
              Links Rápidos
            </h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-300 hover:text-[#C9A961] transition-colors"
                >
                  Início
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-[#C9A961] transition-colors"
                >
                  Sobre Nós
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-[#C9A961] transition-colors"
                >
                  Serviços
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-gray-300 hover:text-[#C9A961] transition-colors"
                >
                  Produtos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-[#C9A961] transition-colors"
                >
                  Contato
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#C9A961]">
              Nossos Serviços
            </h3>
            <ul className="space-y-3 text-gray-300">
              <li>Intermediação Internacional</li>
              <li>Curadoria de Fornecedores</li>
              <li>Gestão Logística</li>
              <li>Importação sob Demanda</li>
              <li>Consultoria Especializada</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-[#C9A961]">
              Contato
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-[#C9A961] flex-shrink-0 mt-1" />
                <a
                  href="tel:+552199565-9798"
                  className="text-gray-300 hover:text-[#C9A961] transition-colors"
                >
                  +55 21 99565-9798
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#C9A961] flex-shrink-0 mt-1" />
                <a
                  href="mailto:contato@interproducts.com.br"
                  className="text-gray-300 hover:text-[#C9A961] transition-colors"
                >
                  contato@interproducts.com.br
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#C9A961] flex-shrink-0 mt-1" />
                <span className="text-gray-300">
                  Rio de Janeiro, Brasil
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 mt-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col space-y-2 text-center md:text-left">
              <p className="text-gray-400 text-sm">
                © {currentYear} InterProducts. Todos os direitos reservados.
              </p>
              <p className="text-[#C9A961] text-xs uppercase tracking-wider font-semibold">
                Desenvolvido por Grafeno Ventures
              </p>
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-[#C9A961] transition-colors">
                Política de Privacidade
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C9A961] transition-colors">
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
